import { useQuery } from '@tanstack/react-query'

import { getFraudLockedCardTransaction } from '@src/api'
import { DefaultApiGetFraudLockedCardTransactionRequest } from '@src/api/generated/user-api'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks'

export const useFetchFraudLockedCardTransaction = (
  params: DefaultApiGetFraudLockedCardTransactionRequest
) => {
  const { axiosInstance } = useAxios()

  return useQuery({
    enabled: !!params.organizationId && !!params.cardId,
    queryFn: () => getFraudLockedCardTransaction(axiosInstance, params),
    queryKey: [
      REACT_QUERY_CACHE_KEYS.GET_FRAUD_LOCKED_CARD_TRANSACTION,
      params.organizationId,
      params.cardId,
    ],
    staleTime: Infinity,
  })
}
